import React from 'react';

const MiniLoader = () => {
    return (
        <div class="thumb-loading">
            <div class="loader-ring">
            <img src="layout_2/assests/loader.png" />
            </div>
        </div>
    );
};

export default MiniLoader;